module.exports = __webpack_public_path__ + "img/206.63b345db.jpg";